import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=290891da&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=290891da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290891da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('290891da')) {
      api.createRecord('290891da', component.options)
    } else {
      api.reload('290891da', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=290891da&scoped=true&", function () {
      api.rerender('290891da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gNK8t62JzWNO/JS/comp/GuestBox.vue"
export default component.exports